import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeFirestore } from 'firebase/firestore';

import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export const firebaseApp = initializeApp(CONFIG.firebase);
export const STORAGE = getStorage(firebaseApp);

// `ignoreUndefinedProperties` strips undefined values from any write payload
// instead of throwing "Unsupported field value: undefined". Without this, any
// optional field on a typed model (e.g. ModifierConfig.optional, Item.out_of_stock_location_ids)
// would crash updateDoc whenever it wasn't explicitly set.
export const FIRESTORE = initializeFirestore(firebaseApp, {
  ignoreUndefinedProperties: true,
});
export const AUTH = getAuth(firebaseApp);
export const FUNCTIONS = getFunctions(firebaseApp);
